var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_520)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68834 0C4.34633 0 0 4.34633 0 9.68834C0 15.0306 4.34633 19.3767 9.68834 19.3767C15.0306 19.3767 19.3767 15.0306 19.3767 9.68834C19.3767 4.34633 15.0306 0 9.68834 0ZM9.68834 17.5881C5.33246 17.5881 1.78862 14.0442 1.78862 9.68838C1.78862 5.33251 5.33246 1.78862 9.68834 1.78862C14.0442 1.78862 17.5881 5.33246 17.5881 9.68834C17.5881 14.0442 14.0442 17.5881 9.68834 17.5881Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.738 20.4734L16.6106 15.346C16.2612 14.9966 15.6954 14.9966 15.346 15.346C14.9966 15.6951 14.9966 16.2615 15.346 16.6106L20.4734 21.738C20.6481 21.9126 20.8767 22 21.1057 22C21.3343 22 21.5633 21.9126 21.738 21.738C22.0873 21.3889 22.0873 20.8225 21.738 20.4734Z",
    fill: "black",
    fillOpacity: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_520"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.4d008e38012a48d1730d8e8bd496ed38.svg";
export { ForwardRef as ReactComponent };